import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";
import { setupAxiosAuthInterceptor } from "./utils/axiosAuthInterceptor";

setupAxiosAuthInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
// Updated for api-demo backend
